import { createSelector } from 'reselect';
import { getSelectorRoot } from 'utils/selectors';
import { getOpenBetsData } from 'store/selectors/betslip/openBets';

export const getBetSlip = getSelectorRoot('betSlip');

export const getSelected = getBetSlip('selected');
export const getSystem = getBetSlip('system');
// @Todo need to change this selector after moving system bet (combinations, selectedCombinationIndex ...) into redux
export const getEditBet = getBetSlip('editBet');
export const getEditableBetTicket = createSelector(
  [getOpenBetsData, getEditBet],
  (openBets, editBet) =>
    editBet?.active && editBet?.betId
      ? openBets?.find(({ id }) => id === editBet.betId)
      : null
);

export const getCashoutFrom = getBetSlip('cashoutFrom');
export const getCashOutTicket = getBetSlip('cashOutTicket');
export const getSportBonuses = getBetSlip('sportBonuses');
export const getSingleReturn = getBetSlip('singleReturn');
export const getIsCalculating = getBetSlip('isCalculating');
export const getCalculationLoading = getBetSlip('calculationLoading');

export const getBasicEw = getBetSlip('basicEw');

export const getSelectedSystem = getBetSlip('selectedSystem');

export const getPossibleSystemCombinations = getBetSlip(
  'possibleSystemCombinations'
);
export const getSystemMinCombinationsCount = getBetSlip(
  'systemMinCombinationsCount'
);

export * from './bets';
export * from './odds';
export * from './stake';
export * from './configs';
export * from './freeBet';
export * from './features';
export * from './openBets';
export * from './profitBoost';
export * from './calculations';
export * from './counterOffer';
